import React from 'react'

import sharesquare from '../Sponsors/Sponsors/Sharesquare logo.png'
import merahoardings from '../Sponsors/Sponsors/Merahording.png'
import rysum from '../Sponsors/Sponsors/Rysum logo.png'
import exicom from '../Sponsors/Sponsors/exicom logo.png'
import redFM from '../Sponsors/Sponsors/redFM.jpg';
import Telangana from '../Sponsors/Sponsors/Telangana_Tourism.jpg'

const SectionSponsors = () => {
  return (
   <section className='md:mx-10 mt-10 mx-1'>
    <div className='bg-white justify-center items-center rounded-t-2xl shadow-[#3b0067] shadow-inner'>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 my-2 font-semibold'>Principal Sponsor</h2>
        <div className='md:flex grid grid-flow-row items-center justify-center gap-4 py-4'>
            <a href='https://tourism.telangana.gov.in/' target='blank'>
                <img src={Telangana} alt="Telangana" />
            </a>
        </div>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 my-2 font-semibold'>Investment Sponsor</h2>
        <div className='md:flex grid grid-flow-row items-center justify-center gap-4 py-4'>
            <a href='https://sharesquare.ae/' target='blank'>  
                <img src={sharesquare} alt="Sharesquare" />
            </a>
        </div>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 font-semibold'>Entertainment partner </h2>
        <div className='md:flex grid grid-flow-row  items-center justify-center gap-4 py-4'>
            <a href='https://www.redfmindia.in/' target='blank'>
                <img src={redFM} alt="Red FM" />
            </a>
        </div>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 font-semibold'>Kit Partner </h2>
        <div className='md:flex grid grid-flow-row  items-center justify-center gap-4 py-4'>
            <a href='https://rysumsports.com/' target='blank'>
                <img src={rysum} alt="RYSUM SPORTS" />
            </a>
        </div>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 font-semibold'>Outdoor Media Partner</h2>
        <div className='md:flex grid grid-flow-row  items-center justify-center gap-4 py-4'>
            <a href='http://www.merahoardings.com/' target='blank'>
                <img src={merahoardings} alt="Merahording" />
            </a>
        </div>
        <h2 className='text-center text-[#3b0067] text-3xl p-3 font-semibold'>Associate Sponsor</h2>
        <div className='md:flex grid grid-flow-row  items-center justify-center gap-4 py-4'>
            <a href='https://www.exicom.com/' target='blank'>
                <img src={exicom} alt="Exicom" />
            </a>
        </div>
    </div>
   </section>
  )
}

export default SectionSponsors